import { DealerID } from "./Dealer";

export type KeyloopMappingID = number;

export enum KEYLOOP_MAPPING_TYPE {
  Make = 1,
  Model = 2,
  Variant = 3,
  Vehicle = 4
}

export interface KeyloopMapping {
  created_on: string;
  id: KeyloopMappingID; // Identifier of the Keyloop mapping
  provider_id: string; // Identifier of the provider in Keyloop
  value: string; // Claire value being mapped
  code: string; // Keyloop code for the value
  dealer_id: DealerID; // Identifier of the dealer this mapping belongs to
  mapping_type: KEYLOOP_MAPPING_TYPE; // Type of value this mapping represents
}
